import React, { useState } from 'react';
import omit from 'lodash/omit';
import uniqueId from 'lodash/uniqueId';
import { isShallowEqual } from '../../../common/utils/is-shallow-equal';
import { useContextSelector, createContext } from '../../use-context-selector';
export const ModalContext = createContext({
    showModal: () => null,
    modals: {},
});
export const ModalProvider = (props) => {
    const [modals, setModals] = useState({});
    const addModal = React.useCallback((id, modal) => {
        setModals((m) => ({
            ...m,
            [id]: { modal, prevFocusOwner: document.activeElement },
        }));
    }, []);
    const toggle = React.useCallback((id) => () => {
        setModals((m) => {
            const element = m[id].prevFocusOwner;
            element && element.focus();
            return omit(m, id);
        });
    }, []);
    const showModal = React.useCallback((modalFn) => {
        const id = uniqueId();
        addModal(id, modalFn(toggle(id)));
    }, [addModal, toggle]);
    return (React.createElement(ModalContext.Provider, { value: React.useMemo(() => ({ showModal, modals }), [showModal, modals]) }, props.children));
};
export const useModal = () => useContextSelector(ModalContext, (ctx) => ctx.showModal, isShallowEqual);
//# sourceMappingURL=use-modal.js.map